// export const API_URL = "http://localhost:5000/";
// export const API_URL = "http://3.89.200.48:5000/";
export const API_URL = "https://api.sossms.com/";
